import {
  PoleClassification,
  Region,
} from '../../../../../../api/theHive/redeProto/types';
import {
  CLASSIFICATION_LABEL,
  REGIONS,
} from '../../../../../../constants/redeProto';
import { PoleDetail } from '../../components/PoleDetail';
import { SectionCard } from '../../components/SectionCard';
import { StateFeedback } from '../../components/StateFeedback';
import { StatusPill } from '../../components/StatusPill';
import { csatColor, heatColor } from '../../theme/tokens';
import { formatCsat, formatPct } from '../../utils/format';
import {
  Badge,
  Badges,
  Count,
  Layout,
  List,
  Name,
  PlanLabel,
  PlanTextarea,
  Row,
  RowTop,
  SavePlanButton,
  SearchInput,
  Select,
  Sub,
  Toolbar,
} from './styles';
import useCriticalPoles from './useCriticalPoles';

export function CriticalPoles(): JSX.Element {
  const {
    filteredPoles,
    ufOptions,
    statusOptions,
    region,
    setRegion,
    uf,
    setUf,
    status,
    setStatus,
    search,
    setSearch,
    selectedPole,
    selectPole,
    actionPlan,
    setActionPlan,
    savePlan,
    savingPlan,
    loading,
    error,
  } = useCriticalPoles();

  return (
    <StateFeedback loading={loading} error={error} empty={false}>
      <Toolbar>
        <Select
          value={region}
          onChange={(event) => {
            setRegion(event.target.value as Region | 'all');
            setUf('all');
          }}
        >
          <option value="all">Todas as regiões</option>
          {REGIONS.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Select value={uf} onChange={(event) => setUf(event.target.value)}>
          <option value="all">Todas as UFs</option>
          {ufOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Select
          value={status}
          onChange={(event) =>
            setStatus(event.target.value as PoleClassification | 'all')
          }
        >
          <option value="all">Todos os status</option>
          {statusOptions.map((item) => (
            <option key={item} value={item}>
              {CLASSIFICATION_LABEL[item]}
            </option>
          ))}
        </Select>

        <SearchInput
          value={search}
          placeholder="Buscar polo..."
          onChange={(event) => setSearch(event.target.value)}
        />

        <Count>{filteredPoles.length} polos</Count>
      </Toolbar>

      <Layout>
        <SectionCard
          title={`Polos que exigem atenção (${filteredPoles.length})`}
        >
          <List>
            {filteredPoles.map((pole) => (
              <Row
                key={pole.poleId}
                type="button"
                selected={selectedPole?.poleId === pole.poleId}
                onClick={() => selectPole(pole)}
              >
                <RowTop>
                  <Name>{pole.name ?? pole.city}</Name>
                  <StatusPill classification={pole.classification} />
                </RowTop>
                <Sub>
                  {pole.uf} · {pole.region ?? '—'}
                </Sub>
                <Badges>
                  <Badge color={heatColor(pole.achievement)}>
                    Cobertura <strong>{formatPct(pole.achievement)}</strong>
                  </Badge>
                  <Badge color={heatColor(pole.sla)}>
                    SLA <strong>{formatPct(pole.sla)}</strong>
                  </Badge>
                  <Badge color={csatColor(pole.csat)}>
                    CSAT <strong>{formatCsat(pole.csat)}</strong>
                  </Badge>
                </Badges>
              </Row>
            ))}
          </List>
        </SectionCard>

        <SectionCard title="Detalhe e plano de ação">
          <PoleDetail
            pole={selectedPole}
            footer={
              selectedPole && (
                <div>
                  <PlanLabel>Plano de ação</PlanLabel>
                  <PlanTextarea
                    value={actionPlan}
                    placeholder="Descreva as ações para recuperar este polo..."
                    onChange={(event) => setActionPlan(event.target.value)}
                  />
                  <SavePlanButton
                    type="button"
                    onClick={savePlan}
                    disabled={savingPlan}
                  >
                    {savingPlan ? 'Salvando...' : 'Salvar plano'}
                  </SavePlanButton>
                </div>
              )
            }
          />
        </SectionCard>
      </Layout>
    </StateFeedback>
  );
}
